export const ChevronRightIcon = (props) => (
  <svg
    {...props}
    aria-hidden={true}
    id="chevron-right"
    className="chevron-right  icon"
    width="14"
    height="8"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.98.5a.47.47 0 00-.36.16C.54.76.5.86.5 1c0 .14.05.25.14.35l5.8 6.05c.15.16.33.24.56.24.22 0 .41-.08.58-.24l5.79-6.05a.55.55 0 000-.72A.5.5 0 0013 .5a.44.44 0 00-.33.14L7 6.57 1.33.64A.5.5 0 00.98.5z"
    />
  </svg>
)

export const ChevronDownIcon = (props) => (
  <svg
    {...props}
    aria-hidden={true}
    id="chevron-down"
    className="chevron-down  icon"
    width="14"
    height="8"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.98.5a.47.47 0 00-.36.16C.54.76.5.86.5 1c0 .14.05.25.14.35l5.8 6.05c.15.16.33.24.56.24.22 0 .41-.08.58-.24l5.79-6.05a.55.55 0 000-.72A.5.5 0 0013 .5a.44.44 0 00-.33.14L7 6.57 1.33.64A.5.5 0 00.98.5z"
    />
  </svg>
)

export const LockIcon = (props) => (
  <svg
    {...props}
    aria-hidden={true}
    id="lock"
    className="lock icon"
    width="23"
    height="24"
    viewBox="0 0 15 21"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3.98438 5.01562H3C3 5.01562 3 4.95312 3 4.82812C3 4.70312 3 4.59375 3 4.5C3 3.26562 3.4375 2.21094 4.3125 1.33594C5.1875 0.445312 6.25 0 7.5 0C8.73438 0 9.78906 0.445312 10.6641 1.33594C11.5547 2.21094 12 3.26562 12 4.5C12 4.59375 12 4.70312 12 4.82812C12 4.95312 12 5.01562 12 5.01562H10.9922C10.9922 5.01562 10.9922 4.95312 10.9922 4.82812C10.9922 4.70312 10.9922 4.59375 10.9922 4.5C10.9922 3.53125 10.6484 2.71094 9.96094 2.03906C9.28906 1.35156 8.46875 1.00781 7.5 1.00781C6.53125 1.00781 5.70312 1.35156 5.01562 2.03906C4.32812 2.71094 3.98438 3.53125 3.98438 4.5C3.98438 4.59375 3.98438 4.70312 3.98438 4.82812C3.98438 4.95312 3.98438 5.01562 3.98438 5.01562ZM9 12.5156C9 12.0938 8.85156 11.7422 8.55469 11.4609C8.25781 11.1641 7.90625 11.0156 7.5 11.0156C7.07812 11.0156 6.71875 11.1641 6.42188 11.4609C6.14062 11.7422 6 12.0938 6 12.5156C6 12.7812 6.0625 13.0312 6.1875 13.2656C6.32812 13.4844 6.50781 13.6641 6.72656 13.8047L6 16.0078H9L8.25 13.8047C8.46875 13.6641 8.64844 13.4844 8.78906 13.2656C8.92969 13.0312 9 12.7812 9 12.5156ZM15 9V17.0156C15 17.8438 14.7031 18.5469 14.1094 19.125C13.5312 19.7188 12.8281 20.0156 12 20.0156H3C2.17188 20.0156 1.46094 19.7188 0.867188 19.125C0.289062 18.5469 0 17.8438 0 17.0156V9C0 8.17188 0.289062 7.46875 0.867188 6.89062C1.46094 6.29688 2.17188 6 3 6H12C12.8281 6 13.5312 6.29688 14.1094 6.89062C14.7031 7.46875 15 8.17188 15 9ZM13.9922 9C13.9922 8.45312 13.7969 7.98438 13.4062 7.59375C13.0156 7.20312 12.5469 7.00781 12 7.00781H3C2.4375 7.00781 1.96094 7.20312 1.57031 7.59375C1.17969 7.98438 0.984375 8.45312 0.984375 9V17.0156C0.984375 17.5625 1.17969 18.0312 1.57031 18.4219C1.96094 18.8125 2.4375 19.0078 3 19.0078H12C12.5469 19.0078 13.0156 18.8125 13.4062 18.4219C13.7969 18.0312 13.9922 17.5625 13.9922 17.0156V9Z" />
  </svg>
)

export const UserIcon = (props) => (
  <svg
    {...props}
    aria-hidden={true}
    id="user"
    className="user icon"
    width="24"
    height="24"
    viewBox="0 0 16 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.00781 11H6.99219C6.17969 11 5.40625 11.1562 4.67188 11.4688C3.9375 11.7812 3.29688 12.2109 2.75 12.7578C2.21875 13.3047 1.79688 13.9453 1.48438 14.6797C1.15625 15.3984 0.992188 16.1719 0.992188 17V20.3516C0.992188 20.5234 1.05469 20.6719 1.17969 20.7969C1.32031 20.9375 1.47656 21.0078 1.64844 21.0078H14.3516C14.5234 21.0078 14.6719 20.9375 14.7969 20.7969C14.9375 20.6719 15.0078 20.5234 15.0078 20.3516V17C15.0078 16.1719 14.8438 15.3984 14.5156 14.6797C14.2031 13.9453 13.7734 13.3047 13.2266 12.7578C12.6953 12.2109 12.0625 11.7812 11.3281 11.4688C10.5938 11.1562 9.82031 11 9.00781 11ZM14 20H2V17C2 16.6562 2.03125 16.3281 2.09375 16.0156C2.15625 15.6875 2.25781 15.3672 2.39844 15.0547C2.52344 14.7578 2.67188 14.4766 2.84375 14.2109C3.03125 13.9453 3.24219 13.6953 3.47656 13.4609C3.69531 13.2422 3.9375 13.0469 4.20312 12.875C4.48438 12.6875 4.77344 12.5312 5.07031 12.4062C5.36719 12.2656 5.67969 12.1641 6.00781 12.1016C6.33594 12.0391 6.66406 12.0078 6.99219 12.0078H9.00781C9.33594 12.0078 9.66406 12.0391 9.99219 12.1016C10.3203 12.1641 10.6328 12.2656 10.9297 12.4062C11.2266 12.5312 11.5078 12.6875 11.7734 12.875C12.0391 13.0469 12.2891 13.2422 12.5234 13.4609C12.7578 13.6953 12.9609 13.9453 13.1328 14.2109C13.3203 14.4766 13.4766 14.7578 13.6016 15.0547C13.7422 15.3672 13.8438 15.6875 13.9062 16.0156C13.9688 16.3438 14 16.6719 14 17V20ZM8 9.00781C9.10938 9.00781 10.0547 8.61719 10.8359 7.83594C11.6172 7.05469 12.0078 6.10938 12.0078 5C12.0078 3.89062 11.6172 2.94531 10.8359 2.16406C10.0547 1.38281 9.10938 0.992188 8 0.992188C6.89062 0.992188 5.94531 1.38281 5.16406 2.16406C4.38281 2.94531 3.99219 3.89062 3.99219 5C3.99219 6.10938 4.38281 7.05469 5.16406 7.83594C5.94531 8.61719 6.89062 9.00781 8 9.00781ZM5.86719 2.86719C6.16406 2.58594 6.49219 2.375 6.85156 2.23438C7.21094 2.07812 7.59375 2 8 2C8.40625 2 8.78906 2.07812 9.14844 2.23438C9.50781 2.375 9.83594 2.58594 10.1328 2.86719C10.4141 3.16406 10.625 3.49219 10.7656 3.85156C10.9219 4.21094 11 4.59375 11 5C11 5.40625 10.9219 5.78906 10.7656 6.14844C10.625 6.50781 10.4141 6.83594 10.1328 7.13281C9.83594 7.41406 9.50781 7.63281 9.14844 7.78906C8.78906 7.92969 8.40625 8 8 8C7.59375 8 7.21094 7.92969 6.85156 7.78906C6.49219 7.63281 6.16406 7.41406 5.86719 7.13281C5.58594 6.83594 5.36719 6.50781 5.21094 6.14844C5.07031 5.78906 5 5.40625 5 5C5 4.59375 5.07031 4.21094 5.21094 3.85156C5.36719 3.49219 5.58594 3.16406 5.86719 2.86719Z"
      fill="white"
    />
  </svg>
)

export const BackIcon = (props) => (
  <svg
    {...props}
    aria-hidden={true}
    id="back"
    className="back icon"
    width="12"
    height="20"
    viewBox="0 0 12 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.25 0.964844C11.25 0.764929 11.1705 0.588417 11.0114 0.436287C10.8717 0.302687 10.6973 0.241249 10.4883 0.251001C10.2793 0.259779 10.1049 0.331942 9.9652 0.464567L0.883927 9.15062C0.645322 9.37881 0.525 9.65967 0.525 9.99319C0.525 10.3267 0.645322 10.6163 0.883927 10.864L9.9652 19.5501C10.1243 19.6827 10.3037 19.75 10.5036 19.75C10.7024 19.75 10.8819 19.6827 11.041 19.5501C11.1807 19.397 11.25 19.2214 11.25 19.0215C11.25 18.8216 11.1807 18.6549 11.041 18.5213L2.13813 10.0068L11.041 1.4934C11.1807 1.34127 11.25 1.16476 11.25 0.964844Z"
    />
  </svg>
)

export const CloseIcon = (props) => (
  <svg
    {...props}
    aria-hidden={true}
    id="close-app"
    className="close-app icon"
    width="16"
    height="22"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8281 14.9766C15.9375 15.1016 15.9922 15.25 15.9922 15.4219C15.9922 15.5781 15.9375 15.7109 15.8281 15.8203C15.7031 15.9453 15.5547 16.0078 15.3828 16.0078C15.2266 16.0078 15.0938 15.9453 14.9844 15.8203L8 8.83594L1.01562 15.8203C0.90625 15.9453 0.765625 16.0078 0.59375 16.0078C0.421875 16.0078 0.28125 15.9453 0.171875 15.8203C0.0625 15.7109 0.0078125 15.5781 0.0078125 15.4219C0.0078125 15.25 0.0625 15.1016 0.171875 14.9766L7.15625 7.99219L0.171875 1.00781C0.0625 0.898438 0.0078125 0.765625 0.0078125 0.609375C0.0078125 0.4375 0.0625 0.289062 0.171875 0.164062C0.296875 0.0546875 0.4375 0 0.59375 0C0.765625 0 0.90625 0.0546875 1.01562 0.164062L8 7.14844L14.9844 0.164062C15.0938 0.0546875 15.2344 0 15.4062 0C15.5781 0 15.7188 0.0546875 15.8281 0.164062C15.9375 0.289062 15.9922 0.4375 15.9922 0.609375C15.9922 0.765625 15.9375 0.898438 15.8281 1.00781L8.84375 7.99219L15.8281 14.9766Z"
      fill="white"
    />
  </svg>
)
